import { render, staticRenderFns } from "./ItemStandard.vue?vue&type=template&id=6fa8cdfb&scoped=true&"
import script from "./ItemStandard.vue?vue&type=script&lang=ts&"
export * from "./ItemStandard.vue?vue&type=script&lang=ts&"
import style0 from "./ItemStandard.vue?vue&type=style&index=0&id=6fa8cdfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa8cdfb",
  null
  
)

export default component.exports